class DiscontinuedRecommendations extends HTMLElement {
  constructor () {
    super()
    this.productContainer = this.querySelector('[data-discontinued-recommendations-el="products"]')
    this.productUrl = `${this.dataset.productUrl}?section_id=bao-discontinued-recommendations`
    this.productId = this.dataset.productId
    this.metaProductRecs = ''
    this.apiProductRecs = ''
    this.availableProductRecs = []
  }

  static observedAttributes = ['data-show']

  attributeChangedCallback () {
    if (this.dataset.show === 'true' && this.dataset.running === 'false') {
      this.dataset.running = 'true'
      this.availableProductRecs = []
      this.metaProductRecs = ''
      this.apiProductRecs = ''
      this.productContainer.innerHTML = ''
      this.updateSelectedOptions()
      this.fetchMetaProductRecs()
    }
  }

  updateSelectedOptions () {
    const productOptions = document.querySelectorAll('#mainProductFormSelection .product-form__input:not(.hidden) input:checked')

    this.dataset.topSize = ''
    this.dataset.bottomSize = ''
    this.dataset.size = ''
    let sizeBottom = ''

    productOptions.forEach(option => {
      switch (option.name) {
        case 'Size-top':
          this.dataset.topSize = `Top / ${option.value} / Normal`
          break
        case 'Size-bottom':
          sizeBottom = option.value
          break
        case 'Style-bottom':
          this.dataset.bottomSize = `Bottom / ${sizeBottom} / ${option.value}`
          break
        case 'Size':
          this.dataset.size = option.value
          break
      }
    })
  }

  async fetchMetaProductRecs () {
    try {
      const response = await fetch(this.productUrl)
      const text = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(text, 'text/html')
      if (doc.body.innerHTML) {
        this.metaProductRecs = doc.body.querySelector('#product-rec-json')
      }
      this.checkMetaVariantsAvailable()
    } catch (error) {
      this.dataset.running = 'false'
      console.error('Error fetching product details:', error)
    }
  }

  checkMetaVariantsAvailable () {
    if (this.metaProductRecs) {
      const productRecsJson = JSON.parse(this.metaProductRecs.textContent)

      productRecsJson.forEach(metaProduct => {
        if (this.availableProductRecs.length < 3) {
          if (this.dataset.topSize && this.dataset.bottomSize) {
            const topMatch = metaProduct.variants.find(variant => variant.title === this.dataset.topSize)
            const bottomMatch = metaProduct.variants.find(variant => variant.title === this.dataset.bottomSize)

            if (topMatch?.available && bottomMatch?.available) {
              if (!this.availableProductRecs.includes(metaProduct.handle)) {
                this.availableProductRecs.push(metaProduct.handle)
                this.injectProduct(metaProduct.url)
              }
            }
          } else if (this.dataset.size) {
            const sizeMatch = metaProduct.variants.find(variant => variant.title === this.dataset.size)

            if (sizeMatch?.available) {
              if (!this.availableProductRecs.includes(metaProduct.handle)) {
                this.availableProductRecs.push(metaProduct.handle)
                this.injectProduct(metaProduct.url)
              }
            }
          }
        }
      })
    }

    if (this.availableProductRecs.length < 3) {
      this.fetchShopifyApiRecs()
    }
  }

  async fetchShopifyApiRecs () {
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${this.productId}`)
      const json = await response.json()

      this.apiProductRecs = json
      this.checkApiVariantsAvailable()
    } catch (error) {
      this.dataset.running = 'false'
      console.error('Error fetching product details:', error)
    }
  }

  checkApiVariantsAvailable () {
    if (this.apiProductRecs) {
      this.apiProductRecs.products.forEach(apiProduct => {
        if (this.availableProductRecs.length < 3) {
          if (this.dataset.topSize && this.dataset.bottomSize) {
            const topMatch = apiProduct.variants.find(variant => variant.title === this.dataset.topSize)
            const bottomMatch = apiProduct.variants.find(variant => variant.title === this.dataset.bottomSize)

            if (topMatch?.available && bottomMatch?.available) {
              if (!this.availableProductRecs.includes(apiProduct.handle)) {
                this.availableProductRecs.push(apiProduct.handle)
                this.injectProduct(`/products/${apiProduct.handle}`)
              }
            }
          } else if (this.dataset.size) {
            const sizeMatch = apiProduct.variants.find(variant => variant.title === this.dataset.size)

            if (sizeMatch?.available) {
              if (!this.availableProductRecs.includes(apiProduct.handle)) {
                this.availableProductRecs.push(apiProduct.handle)
                this.injectProduct(`/products/${apiProduct.handle}`)
              }
            }
          }
        }
      })
    }
    this.dataset.running = 'false'
  }

  async injectProduct (prodUrl) {
    try {
      const response = await fetch(`${prodUrl}?section_id=card-product-model`)
      const text = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(text, 'text/html')
      if (doc.body.innerHTML) {
        this.productContainer.appendChild(doc.body.querySelector('product-card'))
      }
    } catch (error) {
      this.dataset.running = 'false'
      console.error('Error fetching product details:', error)
    }
  }
}

window.customElements.define('discontinued-recommendations', DiscontinuedRecommendations)
